import React, { useEffect, useState } from "react";
import { Form, Input, InputNumber, Select } from "antd";
import { ReportingExportService } from "../Services/ReportingExportService";

const { Option } = Select;

const DocumentForm = ({ modalContent, form, resetFieldsOnClose }) => {
  const [fournis, setFournis] = useState([]);
  const [adherents, setAdherents] = useState([]);
  const [particip, setParticip] = useState([]);
  const [prestats, setPrestats] = useState([]);

  const reportingExportService = new ReportingExportService();

  useEffect(() => {
    const fetchData = async () => {
      try {
        switch (modalContent) {
          case "Nombre de Documents":
            const prestaData =
              await reportingExportService.getAllPrestaReport();

            const partData =
              await reportingExportService.getAllParticipReport();
            const fourniData =
              await reportingExportService.getAllFournisReport();
            const adherData = await reportingExportService.getAllAdherReport();

            setPrestats(prestaData);
            setParticip(partData);
            setFournis(fourniData);
            setAdherents(adherData);
            break;
          case "Charges Techniques VS Cotisations":

            const adhersData2 = await reportingExportService.getAllAdherReport();

            setAdherents(adhersData2);

            break;
          case "Charges Techniques":
            const prestaData1 =
              await reportingExportService.getAllPrestaReport();
            /* const partData1 =
              await reportingExportService.getAllParticipReport(); */
            const fourniData1 =
              await reportingExportService.getAllFournisReport();
            const adhersData = await reportingExportService.getAllAdherReport();
            setPrestats(prestaData1);
            //setParticip(partData1);
            setAdherents(adhersData);
            setFournis(fourniData1);
            break;
          case "Recherche Population Sociale":
            // Récupération des données spécifiques pour la recherche de population sociale
            break;
          default:
            break;
        }
      } catch (error) {
        console.error("Erreur lors de la récupération des données :", error);
      }
    };

    fetchData();
  }, [modalContent]);

  useEffect(() => {
    const resetForm = () => {
      form.resetFields(); // Réinitialise tous les champs du formulaire

    };

    resetForm();

    return () => {
      resetFieldsOnClose(); // Appel de la fonction de réinitialisation lorsque le composant est démonté
    };
  }, [resetFieldsOnClose]);

  const handleSocieteChange = async (value) => {
    try {
      let participantsData;

      participantsData = await reportingExportService.getAllParticipReport(
        value
      );

      setParticip(participantsData);
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des données du participant :",
        error
      );
    }
  };

  const renderFormItems = () => {
    switch (modalContent) {
      case "Nombre de Documents":
        return (
          <>
            <Form.Item name="compte" label="Prestation" initialValue="all">
              <Select showSearch placeholder="Sélectionnez une prestation">
                <Option value="all">Tous</Option>
                {prestats.map((presta) => (
                  <Option key={presta.codeprest} value={presta.compte}>
                    {presta.codeprest} - {presta.intitule}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item name="part" label="Participant" initialValue="all">
              <Select showSearch placeholder="Sélectionnez un participant" >
                <Option value="all">Tous</Option>
                {particip.map((part) => (
                  <Option key={part.codepart} value={part.codepart}>
                    {part.codepart} - {part.intitule}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item name="fourn" label="Fournisseur" initialValue="all">
              <Select showSearch placeholder="Sélectionnez un fournisseur">
                <Option value="all">Tous</Option>
                {fournis.map((fourni) => (
                  <Option key={fourni.numFourn} value={fourni.numFourn}>
                    {fourni.numFourn} - {fourni.raisoc}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item name="soc" label="Adhérent" initialValue="all">
              <Select showSearch placeholder="Sélectionnez un adhérent">
                <Option value="all">Tous</Option>
                {adherents.map((adher) => (
                  <Option key={adher.codeadht} value={adher.codeadht}>
                    {adher.codeadht} - {adher.intitule}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item name="typeBenef" label="Type de bénéficiaire" initialValue="all">
              <Select placeholder="Sélectionnez un type">
                <Option value="all">Tous</Option>
                <Option value="1">Participant</Option>
                <Option value="2">Épouse</Option>
                <Option value="3">Enfant</Option>
                <Option value="4">Époux</Option>
                <Option value="5">Ascendant</Option>
                <Option value="6">Autre</Option>
                <Option value="7">Enf.Majeurs</Option>
              </Select>
            </Form.Item>
          </>
        );

      case "Charges Techniques":
        return (
          <>
            <Form.Item name="compte" label="Prestation" initialValue="all" >
              <Select
                showSearch
                filterOption={(input, option) =>
                  option.children
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                placeholder="Sélectionnez une prestation">
                <Option value="all">Tous</Option>
                {prestats.map((presta) => (
                  <Option key={presta.codeprest} value={presta.compte}>
                    {` ${presta.codeprest} - ${presta.intitule}`}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item name="codesoc" label="Adhérent" initialValue="all">
              <Select
                filterOption={(input, option) =>
                  option.children
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                onChange={handleSocieteChange} showSearch placeholder="Sélectionnez un adhérent">
                <Option value="all">Tous</Option>
                {adherents.map((adher) => (
                  <Option key={adher.codeadht} value={adher.codeadht}>
                    {` ${adher.codeadht} - ${adher.intitule}`}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item name="part" label="Participant" initialValue="all">
              <Select
                filterOption={(input, option) =>
                  option.children
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                showSearch placeholder="Sélectionnez un participant">
                <Option value="all">Tous</Option>
                {particip.map((part) => (
                  <Option key={part.numcont} value={part.numcont}>
                    {`${part.matricule} - ${part.part}`}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item name="fourn" label="Fournisseur" initialValue="all">
              <Select
                filterOption={(input, option) =>
                  option.children
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                showSearch placeholder="Sélectionnez un fournisseur">
                <Option value="all">Tous</Option>
                {fournis.map((fourni) => (
                  <Option key={fourni.numFourn} value={fourni.numFourn}>
                    {`${fourni.numFourn} - ${fourni.raisoc}`}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </>
        );
      case "Charges Techniques VS Cotisations":
        return (
          <>


            <Form.Item name="soc" label="Adhérent" initialValue="all">
              <Select
                filterOption={(input, option) =>
                  option.children
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                onChange={handleSocieteChange} showSearch placeholder="Sélectionnez un adhérent">
                <Option value="all">Tous</Option>
                {adherents.map((adher) => (
                  <Option key={adher.codeadht} value={adher.codeadht}>
                    {` ${adher.codeadht} - ${adher.intitule}`}
                  </Option>
                ))}
              </Select>
            </Form.Item>

          </>
        );

      case "Recherche Population Sociale":
        return (
          <>
            <Form.Item name="sexe" label="Sexe">
              <Select placeholder="Sélectionnez le sexe">
                <Option value="MA">Masculin</Option>
                <Option value="FE">Féminin</Option>
              </Select>
            </Form.Item>
            <Form.Item name="age" label="Age (min-max)">
              <InputNumber style={{ width: "100%" }} placeholder="Min-Max" />
            </Form.Item>
            <Form.Item name="typeBenef" label="Type de bénéficiaire">
              <Select placeholder="Sélectionnez un type">
                <Option value="all">Tous</Option>
                <Option value="1">Participant</Option>
                <Option value="2">Épouse</Option>
                <Option value="3">Enfant</Option>
                <Option value="4">Époux</Option>
                <Option value="5">Ascendant</Option>
                <Option value="6">Autre</Option>
                <Option value="7">Enf.Majeurs</Option>
              </Select>
            </Form.Item>
            <Form.Item name="localite" label="Localité">
              <Input placeholder="Entrez la localité" />
            </Form.Item>
          </>
        );

      default:
        return null;
    }
  };

  return (
    <Form form={form} layout="vertical">
      {renderFormItems()}
    </Form>
  );
};

export default DocumentForm;
